"use strict";

var _interopRequireDefault = require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _slicedToArray2 = _interopRequireDefault(require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime-corejs2/helpers/slicedToArray"));

var _oss = require("../../../utils/oss");

var _util = require("../../../utils/util");

var _fileUtil = require("../../../utils/file/fileUtil");

//
//
//
//
//
//
//
//
//
//
var _default = {
  props: {
    value: {
      type: String,
      default: undefined
    }
  },
  data: function data() {
    return {
      fileData: null,
      loading: false
    };
  },
  computed: {
    valueProxy: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  },
  watch: {
    loading: {
      handler: function handler(val) {
        this.$emit('uploadAudio', val);
      }
    }
  },
  created: function created() {
    console.log(this.value);
  },
  methods: {
    // 从 input 的 event 中获取 file
    getFirstFile: function getFirstFile(_ref) {
      var srcElement = _ref.srcElement,
          target = _ref.target;

      var _ref2 = target || srcElement,
          files = _ref2.files; // 获取 files


      if (!files) {
        return undefined;
      }

      var _files = (0, _slicedToArray2.default)(files, 1),
          file = _files[0]; // 获取选中的第一个文件


      if (!file) {
        return undefined;
      }

      return file;
    },
    // 过滤文件类型
    verification: function verification(_ref3) {
      var type = _ref3.type;
      console.log(type);
      return ['audio/mp3'].includes(type);
    },
    upload: function () {
      var _upload2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
        var names, file, exname, name, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                names = ['mp3'];
                this.loading = true;
                _context.prev = 2;
                file = this.getFirstFile(event);
                this.fileData = file;

                if (this.fileData) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return");

              case 7:
                exname = (0, _fileUtil.parseFileName)(this.fileData.name)[1].toLowerCase();
                name = (0, _fileUtil.parseFileName)(this.fileData.name)[0].toLowerCase();

                if (!(names.indexOf(exname) < 0)) {
                  _context.next = 11;
                  break;
                }

                throw new Error("\u4E0D\u652F\u6301\u7684\u6587\u4EF6\u7C7B\u578B\uFF1A ".concat(exname));

              case 11:
                _context.next = 13;
                return (0, _oss.upload)(this.fileData, (0, _oss.getPath)("audio/book-content/".concat(name, "/").concat((0, _util.getFileExt)(this.fileData))));

              case 13:
                this.valueProxy = _context.sent;
                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](2);
                message = _context.t0.message;
                this.$notify.error({
                  title: '错误',
                  message: message
                });

              case 20:
                _context.prev = 20;
                this.$refs.uploadControl.value = null;
                this.loading = false;
                return _context.finish(20);

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 16, 20, 24]]);
      }));

      function upload(_x) {
        return _upload2.apply(this, arguments);
      }

      return upload;
    }()
  }
};
exports.default = _default;